module.exports = __webpack_public_path__ + "img/h-page4-9.b36ebf0e.png";